import { CustomMenuItem } from '../../commons/components/GrowegyMenu';

export const createSupportMenuItem = (isHidden: boolean, dataTest?: string): CustomMenuItem => ({
  type: 'custom',
  isHidden,
  dataTest,
  component: () => (
    <div className="app-sidebar__email-us-at-container">
      <div className="app-sidebar__email-us-at">Didn’t find your answer? Email us at</div>
      <a href="mailto:support@growegy.com">support@growegy.com</a>
    </div>
  ),
});
